// src/hooks/hotelMealPlans/useUpdateHotelMealPlan.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateHotelMealPlan } from "../../api/apiHotelMealPlans";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateHotelMealPlan = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: editHotelMealPlan, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updateHotelMealPlan(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Hotel meal plan updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlan"] });
            navigate("/hotel-meal-plans");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update hotel meal plan");
        },
    });

    return { editHotelMealPlans: editHotelMealPlan, isUpdate };
};

export default useUpdateHotelMealPlan;
